import Vue from 'vue';
import IconBase from '@/components/atoms/icons/IconBase.vue';
import IconBarcode from '@/components/atoms/icons/IconBarcode.vue';
import IconCoupon from '@/components/atoms/icons/IconCoupon.vue';
import IconPoint from '@/components/atoms/icons/IconPoint.vue';
import IconHistory from '@/components/atoms/icons/IconHistory.vue';
import IconHelp from '@/components/atoms/icons/IconHelp.vue';

Vue.component('IconBase', IconBase);
Vue.component('IconBarcode', IconBarcode);
Vue.component('IconCoupon', IconCoupon);
Vue.component('IconPoint', IconPoint);
Vue.component('IconHistory', IconHistory);
Vue.component('IconHelp', IconHelp);
